module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Regular.b77054d6.woff";